import { Box, Circle, Flex, Heading, Input, Select } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchResult from "../../../Components/Recruiter/SearchResult/SearchResult_Comp";
import { postActions } from "../../../redux/actions";

const SearchResult1 = () => {
  const filter = useSelector((state) => state.filters.filter);

  const levels = [
    "Foundation",
    "3D NFT Creator",
    "3D Environment Creator",
    "XR Interaction Creator",
    "Simulation Creator",
    "Ajna Creator",
  ];

  return (
    <div>
      <Box p={[5, 5, 20, 20]} pt={10} mt={[12, 12, 16, 16]}>
        <Flex flexDirection="column" align="flex-start" gap={5}>
          {/*Desktop Heading */}
          <Box display={["none", "none", "block", "block"]}>
            <Heading fontSize={32} fontWeight={600}>
              Search Result for {levels[+filter]}
            </Heading>
          </Box>

          {/* Mobile Heading */}
          <Box display={["block", "block", "none", "none"]}>
            <Heading fontSize={24} fontFamily={"Epilogue"} fontWeight={600}>
              Search Result
            </Heading>
          </Box>

          {/* Filters */}
          {/* <Flex>
            <Box bg="#D9D9D9" px={2.5} py={1.5} borderRadius={40}>
              <Flex align="center" gap={2}>
                <Circle size={8} bg="#BFBFBF"></Circle>
                <Box>
                  <Select variant="unstyled">
                    <option defaultValue="Add Filter">Add Filter</option>
                    <option value="NFT">NFT</option>
                    <option value="3D_Environment">3D Environment</option>
                    <option value="Digital_Twin">Digital_Twin</option>
                  </Select>
                </Box>
              </Flex>
            </Box>
          </Flex> */}
          <Box w="100%">
            <SearchResult role={levels[+filter]} />
          </Box>
        </Flex>
      </Box>
    </div>
  );
};

export default SearchResult1;
